import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=2cd85e76&scoped=true&"
import script from "./FontSelector.vue?vue&type=script&lang=js&"
export * from "./FontSelector.vue?vue&type=script&lang=js&"
import style0 from "./FontSelector.vue?vue&type=style&index=0&id=2cd85e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd85e76",
  null
  
)

export default component.exports